import {FormType} from '../../../../../blocks/FormBlock'
import {copy} from '../../../../../../util/fieldscopy'

const optin: FormType = {
	amount: null,
	id: 4,
	parent_id: 0,
	channel: 'checkbox',
	name: 'nieuwsbrief',
	label:
		copy?.optin || 'Schrijf me in voor de nieuwsbrief van Broederlijk Delen',
	required: false
}

export default optin
